//=require scripts/state.js
//=require scripts/helpers.js
//=require scripts/config.js
//=require scripts/dropdown.js
//=require scripts/map.js
//=require scripts/formFiles.js
//=require scripts/getStoresData.js
//=require scripts/orderSelectionMap.js
//=require scripts/sliders.js
//=require scripts/initContacts.js
//=require scripts/bestseller-slider.js
//=require scripts/category-slider.js
//=require scripts/product-card-slider.js
//=require scripts/complect-slider.js
//=require scripts/advantages-slider.js
//=require scripts/site-footer.js
//=require scripts/site-header.js
//=require scripts/product-gallery.js
//=require scripts/product-features-slider.js
//=require scripts/product-gallery-modal.js
//=require scripts/tabs.js
//=require scripts/initStretch.js
//=require scripts/geoIp.js
//=require scripts/modals.js
//=require scripts/initSelect.js
//=require scripts/datepicker.js
//=require scripts/ordersFilter.js
//=require scripts/rating.js
//=require scripts/lkSidebar.js
//=require scripts/modalMessage.js
//=require scripts/installmentPlan.js
//=require scripts/paymentEntity.js
//=require scripts/checkCookie.js
//=require scripts/productCompareAndFavorite.js
//=require scripts/setComparisonAndFavorites.js
//=require scripts/showModalAddsToCart.js
//=require scripts/showModalProductAdmission.js
//=require scripts/select.js
//=require scripts/orderDelivery.js
//=require scripts/lkComparison.js
//=require scripts/limitTextarea.js
//=require scripts/attachment-file.js
//=require scripts/filters.js
//=require scripts/catalog-filters.js
//=require scripts/range-slider.js
//=require scripts/scrollToUp.js
//=require scripts/initValidate.js
//=require scripts/product-card-page.js
//=require scripts/validateForm.js
//=require scripts/dsoForm.js
//=require scripts/smartCaptcha.js
//=require scripts/popupCookie.js
//=require scripts/productSearchPanel.js
//=require scripts/modalPrefill.js
//=require scripts/dadata.js
//=require scripts/phoneConfirm.js
//=require scripts/oneClickBuy.js
//=require scripts/moreList.js
//=require scripts/comments.js
//=require scripts/tab.js
//=require scripts/orderReviewModal.js
//=require scripts/productCardInfo.js
//=require scripts/cartDelete.js
//=require scripts/stickySumCart.js
//=require scripts/informerModal.js
//=require scripts/yaMetrika.js
//=require scripts/connectPanel.js

//=require scripts/scripts.js
